// extracted by mini-css-extract-plugin
module.exports = {"baseLink":"styles-module__baseLink___IFU7G"};